module.exports = __webpack_public_path__ + "229e776da839b28508c576ef208c7b68.jpg";